export default __webpack_public_path__ + "static/media/order.3fc82d12.svg";